import React, {
	useState,
	createRef,
	useRef,
	useEffect,
	cloneElement,
} from 'react';

enum Mode {
	VIEW,
	EDIT,
}

type Props = {
	view: JSX.Element;
	edit: JSX.Element;
	onModeChange: (isEditMode: boolean) => void;
};

const ViewEdit: React.FunctionComponent<Props> = ({
	view,
	edit,
	onModeChange,
}) => {
	const editRef = createRef();
	const hasMounted = useRef(false);
	const [mode, setMode] = useState<Mode>(Mode.VIEW);

	const viewComponent = cloneElement(view, {
		forwardedRef: editRef,
		onModeChange: () => setMode(Mode.EDIT),
	});

	const editComponent = cloneElement(edit, {
		onModeChange: () => setMode(Mode.VIEW),
	});

	useEffect(() => {
		if (hasMounted.current) {
			if (mode === Mode.VIEW && editRef.current != null) {
				//@ts-ignore
				editRef.current.focus();
			}
			onModeChange(mode === Mode.EDIT ? true : false);
		}
		hasMounted.current = true;
	}, [mode]);

	return mode === Mode.VIEW ? (
		<React.Fragment>{viewComponent}</React.Fragment>
	) : (
		<React.Fragment>{editComponent}</React.Fragment>
	);
};

export default ViewEdit;
